module.exports = __webpack_public_path__ + "static/CaslonGraD.331e456e.woff2";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/CaslonGraD.woff2
// module id = 711
// module chunks = 168707334958949